import { render, staticRenderFns } from "./DialogUI.vue?vue&type=template&id=80788d8a&"
import script from "./DialogUI.vue?vue&type=script&lang=js&"
export * from "./DialogUI.vue?vue&type=script&lang=js&"
import style0 from "./DialogUI.vue?vue&type=style&index=0&id=80788d8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports